import Nullstack from 'nullstack';
export default function IconTargetArrow({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-target-arrow",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "1"
  }), "   ", Nullstack.element("path", {
    d: "M12 7a5 5 0 1 0 5 5"
  }), "   ", Nullstack.element("path", {
    d: "M13.004 3.055a9 9 0 1 0 7.941 7.945"
  }), "   ", Nullstack.element("path", {
    d: "M15 6v3h3l3 -3h-3v-3z"
  }), "   ", Nullstack.element("path", {
    d: "M15 9l-3 3"
  }), " ");
}